import type { AiChatMessage } from '../../ai-chat-types';

/**
 * Joins an assistant (or any) message's text parts into a single string for copy/download.
 * Parts are separated by a blank line so a later `## heading` stays a heading, matching the
 * on-screen stack of text blocks around tool calls.
 */
export const getAssistantMessageText = (message: AiChatMessage): string =>
  message.parts
    .filter((part) => part.type === 'text')
    .map((part) => (part.type === 'text' ? (part.text ?? '').trim() : ''))
    .filter(Boolean)
    .join('\n\n');
